import { type ReactNode } from 'react'

interface FullScreenMessageProps {
  title: string
  description: string
  action?: ReactNode
}

/** Centered message used for empty, error and unsupported-environment screens. */
export function FullScreenMessage({ title, description, action }: FullScreenMessageProps) {
  return (
    <main className="flex min-h-viewport flex-col items-center justify-center gap-3 px-4 pt-safe pb-safe text-center">
      <h1 className="text-xl font-bold text-ink">{title}</h1>
      <p className="max-w-xs text-sm text-secondary">{description}</p>
      {action ? <div className="mt-2">{action}</div> : null}
    </main>
  )
}
